import React, { useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { useSearchParams} from "react-router-dom";
import {Stack, Button, CircularProgress,Backdrop,Box,MenuItem,Dialog, DialogActions,DialogContent,DialogContentText,DialogTitle, TextField, FormHelperText, Checkbox, FormControlLabel, Select, Radio, RadioGroup, ListItemText } from '@mui/material';
import axios from 'axios';

function Contact() {

  const [searchParams] = useSearchParams();
  let category = searchParams.get("category")

  let default_p1= searchParams.get("d1")
  let campaignId= searchParams.get("ca")

  

  let subTitle=""
  let q1Title="";
  let q1List=[]

  switch(category){

    case "service":
        subTitle="サービスに関する"
        q1Title = "該当するサービスを選択してください（複数選択可）"
        q1List =[
            "えるぼし認定支援取得サービス",
            "クラウド社労士コモン",
            "給与計算BPO",
            "助成金コーディネート／助成金Sensei",
            // "HR Sensei",
            "テレワークコーディネート",
            "社労士業務／労務コンテンツ",
            // "処遇改善加算サポート",
            "その他",
        ]
        break;

    case "partner":
        subTitle="士業パートナーに関する"
        q1Title = "該当する士業を選択してください（複数選択可）"
        q1List =[
            "弁護士","公認会計士","税理士","社労士","行政書士","司法書士","中小企業診断士","弁理士","その他"
        ]
        break;

    case "alliance":
        subTitle="業務提携・アライアンスに関する"
        q1Title = "該当するサービスを選択してください（複数選択可）"
        q1List =[
          "えるぼし認定支援取得サービス",
          "クラウド社労士コモン",
          "給与計算BPO",
          "助成金コーディネート／助成金Sensei",
          // "HR Sensei",
          "テレワークコーディネート",
          "社労士業務／労務コンテンツ",
        //   "処遇改善加算サポート",
          "その他",
      ]
        break;

    case "interview":
        subTitle="取材のご依頼に関する"
        q1Title = "該当する取材テーマを選択してください（複数選択可）"
        q1List =[
            "TRIPORTのサービスについて",
            "TRIPORTの働き方・労働環境について",
            "TRIPORTの業務改善への取組について",
            "TRIPORTの事業戦略・財務戦略・人材戦略について",
            "TRIPORTの経営者について",
            "TRIPORTの社員について",
            "その他"
        ]
        break;

    case "seminar":
        subTitle="講演会、共催セミナー等のご依頼に関する"
        q1Title = "該当する講演・セミナーテーマを選択してください（複数選択可）"
        q1List =[
            "TRIPORTのサービスについて",
            "TRIPORTの働き方・労働環境について",
            "TRIPORTの業務改善への取組について",
            "TRIPORTの事業戦略・財務戦略・人材戦略について",
            "TRIPORTの経営者について",
            "TRIPORTの社員について",
            "その他"
        ]
        break;

    
    case "other":
    default:
        category="other"
        subTitle="その他"
      break;

    
  }

  let selectList=[]
  if(default_p1!==null && default_p1.length>0){

    selectList=q1List.filter(i=>{
      return default_p1.indexOf(i)>=0
    })
  }

  const [q1SelectedList, setQ1SelectedList] = useState(selectList);

  const serverUrl=`https://script.google.com/macros/s/AKfycbxkw81A4MIRiprMzVBXY9AkdbmQUg9y4uKOJ1kgr4yxjSya8lY8flkcLeBTfCwshHL0/exec`
  const VALIDATION_REQUIRED="入力が必須の項目です"
  
  const {
      control,
      handleSubmit,
      formState:{
        isValid,
        isSubmitting,
        errors,
      },
  } = useForm({
    mode:"all",
  });
    
  const [isProcessing,setIsProcessing] = useState(false);
  const [dialogInfo,setDialogInfo]=useState(null);
  
  // const [meetingList, setMeetingList]=useState([]);
  const [isCompleted, setIsCompleted]=useState(false);
  
  const RequiredLabel=(props)=>{
    return (
    <Stack mt={2} direction="row" alignItems="center">
      <Box display="inline" mr={1} bgcolor="red" color="white" p={.5} pl={1} pr={1} borderRadius={1} fontSize={12}>必須</Box>
      <Box flex={1}>{props.children}</Box>
    </Stack>)
  }

  
  

  const onSubmit = async(formData)=>{

    try{
        
        // console.log(formData)

        formData.category=category;
        
        setIsProcessing(true)
        
        formData.rm="c9da28f2fc6a4126aad8a45fec601200"
        formData.ca = campaignId
        formData.phone = formData.phone.join("-");
        
        const response = await axios.post(serverUrl,JSON.stringify(formData));
        
        if(response.status !== 200){
            throw new Error(`request error\n${response.status} ${response.statusText}`);
        }

        const {status, message} = response.data;

        switch(status){
            case "OK":
                setIsCompleted(true);
                
                break;

            
            default:
                throw new Error(message);
        }

    }
    catch(ex){
        showErrorMessage(ex.message)
    }
    finally{
        setIsProcessing(false)
    } 
  }

//   const showInfoMessage = (message)=>{
//     setDialogInfo({
//         title:"Infomation",
//         message:message
//     })
//   }

  const showErrorMessage = (message)=>{
      setDialogInfo({
          title:"Error",
          message:message
      })
  }

  
  return (
   
    <>
    <Box component="header" position="fixed" left={0} right={0} top={0} backgroundColor="rgba(255, 255, 255, 0.9)" zIndex={999} boxShadow="1px 1px 2px rgba(0,0,0,0.3)">
        <Stack className='section-content' flexDirection="row" margin="0 auto" justifyContent="space-between" alignItems="center" gap={1} p={1}>
              <Box component="img" alt="header" width={200} src={`${process.env.PUBLIC_URL}/static/media/logo.png`}/>
        </Stack>
    </Box>
    
    <Box p={{xs:1, sm:5}}>
        <Box maxWidth={900} m="0 auto" >
            
          <Box textAlign="center" mt={{xs:10,sm:6}} mb={4} fontWeight="bold" color="white">
            {/* <Box component="img" alt="header" width={200} src={`${process.env.PUBLIC_URL}/static/media/logo.png`}/> */}
            <Box fontSize={{xs:25, sm:30}} lineHeight={1.2}>{subTitle}<Box fontSize={{xs:30, sm:45}}>お問い合わせフォーム</Box></Box>
            
            
          </Box>

          
          <Box paddingY={{xs:1,sm:5}} paddingX={{xs:1,sm:5}} mb={10} backgroundColor="white" borderRadius={1} boxShadow={"rgba(0, 0, 0, 0.5) 2px 2px 8px 0px"}>
              
              {isCompleted===false &&
                  <Box component="form" onSubmit={handleSubmit(onSubmit)}>

                    <Box component="fieldset" disabled={isProcessing} p={0} border="none">
                      
                      {q1List.length>0 &&
                      <>
                        <RequiredLabel>{q1Title}</RequiredLabel>
                        <Controller
                          name={"q1"}
                          control={control}
                          defaultValue={selectList}
                          rules={{
                            required: {value: true, message: VALIDATION_REQUIRED},
                            
                          }}
                          render={({field,fieldState})=>
                            <>
                              {/* <InputLabel className="required" sx={{whiteSpace:"normal"}} error={!!fieldState.error?.message}>{q1Title}</InputLabel> */}
                              {/* <FormHelperText>※複数選択可</FormHelperText> */}
                              <Select
                                // labelId="multiple-checkbox-label"
                                id="multiple-checkbox"
                                {...field}
                                sx={{mt:1}}
                                value={q1SelectedList}
                                multiple
                                autoFocus
                                fullWidth
                                error={!!fieldState.error?.message}
                                //  {...field}
                                onChange={(event) => {
                                  const {
                                    target: { value },
                                  } = event;
                                  setQ1SelectedList(
                                    // On autofill we get a stringified value.
                                    typeof value === 'string' ? value.split(',') : value,
                                  );
                                  field.onChange(value === 'string' ? value.split(',') : value)
                                }}
                                // input={<OutlinedInput label="Tag" />}
                                renderValue={(selected) => selected.join(', ')}
                                
                              >
                                {q1List.map((name,index) => (
                                  <MenuItem key={name} value={name} sx={{whiteSpace:"normal"}}>
                                    <Checkbox checked={q1SelectedList.indexOf(name) > -1} />
                                    <ListItemText primary={name} />
                                  </MenuItem>
                                ))}
                              </Select>
                              <FormHelperText sx={{ml:1}} error={!!fieldState.error?.message}>{fieldState.error?.message}</FormHelperText>
                            </>          
                          }
                        />
                      </>
                      }

                      <RequiredLabel>返信用メールアドレス</RequiredLabel>
                      <Controller
                          name="email"
                          control={control}
                          defaultValue=""
                          rules={{
                            required: {value: true, message: VALIDATION_REQUIRED},
                            pattern:{value:/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,message:'xxx@xxx.xx形式で入力してください'},
                          }}
                          render={({field,fieldState})=>
                            <TextField 
                                {...field}
                                margin="dense"
                                placeholder='xxx@xxx.co.jp'
                                inputMode='email'
                                autoFocus
                                fullWidth
                                error={!!fieldState.error?.message}
                                helperText={fieldState.error?.message}
                                />
                            
                          }
                      />
                      
                      <RequiredLabel>お問い合わせ内容</RequiredLabel>
                      <Controller
                          name="body"
                          control={control}
                          defaultValue={""}
                          rules={{
                              required: {value: true, message: VALIDATION_REQUIRED},
                              maxLength:{value:1000,message:"1000文字以内で入力してください"},
                          }}
                          render={({field,fieldState})=>
                            
                            <TextField 
                                {...field}
                                
                                variant="outlined"
                                margin="dense"
                                multiline
                                rows={10}
                                fullWidth
                                error={!!fieldState.error?.message}
                                helperText={fieldState.error?.message}
                                />
                            
                          }
                      />
                      
                      <RequiredLabel>会社名</RequiredLabel>
                      <Controller
                          name="accountName"
                          control={control}
                          defaultValue={""}
                          rules={{
                              required: {value: true, message: VALIDATION_REQUIRED},
                              maxLength:{value:60,message:"60文字以内で入力してください"},
                          }}
                          render={({field,fieldState})=>
                            
                              <TextField 
                                  {...field}
                                  variant="outlined"
                                  margin="dense"
                                  placeholder='テスト株式会社'
                                  fullWidth
                                  error={!!fieldState.error?.message}
                                  helperText={fieldState.error?.message}
                                  />
                            
                          }
                      />
                      
                      <RequiredLabel>担当者名</RequiredLabel>
                      <Controller
                          name="customerName"
                          control={control}
                          defaultValue={""}
                          rules={{
                              required: {value: true, message: VALIDATION_REQUIRED},
                              maxLength:{value:60,message:"60文字以内で入力してください"},
                          }}
                          render={({field,fieldState})=>
                            
                              <TextField 
                                  {...field}
                                  variant="outlined"
                                  margin="dense"
                                  placeholder='山田　太郎'
                                  fullWidth
                                  error={!!fieldState.error?.message}
                                  helperText={fieldState.error?.message}
                                  />
                            
                          }
                      />

                      <RequiredLabel>担当者名かな</RequiredLabel>
                      <Controller
                        name="customerNameKana"
                        control={control}
                        defaultValue={""}
                        rules={{
                            required: {value: true, message: VALIDATION_REQUIRED},
                            maxLength:{value:60,message:"60文字以内で入力してください"},
                        }}
                        render={({field,fieldState})=>
                          
                          <TextField 
                              {...field}
                              variant="outlined"
                              margin="dense"
                              placeholder='やまだ　たろう'
                              fullWidth
                              error={!!fieldState.error?.message}
                              helperText={fieldState.error?.message}
                              />
                          
                        }
                      />
                      
                      <RequiredLabel>電話番号</RequiredLabel>
                      {/* <Controller
                          name="phone"
                          control={control}
                          defaultValue=""
                          rules={{
                              required: {value: true, message: VALIDATION_REQUIRED},
                              pattern:{value:/^0\d{1,4}[-]?\d{1,4}[-]?\d{4}$/,message:'半角数字で電話番号を入力してください'},
                          }}
                          render={({field,fieldState})=>
                            
                            <TextField 
                                {...field}
                                variant="outlined"
                                margin="dense"
                                placeholder='03-xxxx-xxxx'
                                inputMode='numeric'
                                fullWidth
                                error={!!fieldState.error?.message}
                                helperText={fieldState.error?.message}
                                />
                            
                          }
                      /> */}
                      <Box mt={1}>
                        <Stack direction="row" gap={1} alignItems="center">
                            <Controller
                                name="phone[0]"
                                control={control}
                                defaultValue={""}
                                rules={{
                                    required: {value: true, message: VALIDATION_REQUIRED},
                                    pattern:{value:/^0\d{1,3}$/,message:'error'},
                                }}
                                render={({field,fieldState})=>
                                    
                                    <TextField 
                                        {...field}
                                        // autoFocus
                                        variant="outlined"
                                        margin="none"
                                        placeholder='0000'
                                        InputProps={{
                                            inputProps:{
                                                inputMode: "numeric",
                                                maxLength:4,
                                            },
                                            sx: { backgroundColor: "#fff",width:65 }
                                        }}
                                        
                                        error={!!fieldState.error?.message}
                                        // helperText={fieldState.error?.message}
                                        />
                                        
                                }
                            />
                            -
                            <Controller
                                name="phone[1]"
                                control={control}
                                defaultValue={""}
                                rules={{
                                    required: {value: true, message: VALIDATION_REQUIRED},
                                    pattern:{value:/^\d{1,4}$/,message:'error'},
                                }}
                                render={({field,fieldState})=>
                                    
                                    <TextField 
                                        {...field}
                                        variant="outlined"
                                        margin="none"
                                        placeholder='0000'
                                        InputProps={{
                                            inputProps:{
                                                inputMode: "numeric",
                                                maxLength:4,
                                            },
                                            sx: { backgroundColor: "#fff",width:65 }
                                        }}
                                        
                                        error={!!fieldState.error?.message}
                                        // helperText={fieldState.error?.message}
                                        />
                                        
                                }
                            />
                            -
                            <Controller
                                name="phone[2]"
                                control={control}
                                defaultValue={""}
                                rules={{
                                    required: {value: true, message: VALIDATION_REQUIRED},
                                    pattern:{value:/^\d{4}$/,message:'error'},
                                }}
                                render={({field,fieldState})=>
                                    
                                    <TextField 
                                        {...field}
                                        variant="outlined"
                                        margin="none"
                                        placeholder='0000'
                                        InputProps={{
                                            inputProps:{
                                                inputMode: "numeric",
                                                maxLength:4,
                                            },
                                            sx: { backgroundColor: "#fff",width:65 }
                                        }}
                                        
                                        error={!!fieldState.error?.message}
                                        // helperText={fieldState.error?.message}
                                        />
                                        
                                }
                            />
                        </Stack>
                        {(errors.phone!==undefined) &&
                            <FormHelperText error>電話番号を入力してください</FormHelperText>
                        }
                    
                    </Box>
                      

                      <RequiredLabel>サービスをどちらでお知りになりましたか？</RequiredLabel>
                      <Controller
                        name="whereknow"
                        control={control}
                        defaultValue=""
                        rules={{
                          required: {value: true, message: VALIDATION_REQUIRED},
                        }}
                        render={({field,fieldState})=>  
                          <>
                            {/* <InputLabel className="required" sx={{mt:3,whiteSpace:"normal"}} error={!!fieldState.error?.message}>サービスをどちらでお知りになりましたか？</InputLabel> */}
                            <RadioGroup
                              {...field}
                              name={field.name}
                              onChange={(e) => {
                                // const value = parseInt(e.target.value)
                                // if (!isNaN(value)) {
                                //   field.onChange(value)
                                // }
                                field.onChange(e.target.value)
                              }}
                              value={field.value === undefined ? '' : field.value}
                              >
                              {[
                                "インターネットで検索",
                                "インターネット上の記事",
                                "サービスを知っている方からの紹介",
                                "サービスを使っている方からの紹介",
                                "TRIPORTの提携企業様からの紹介",
                                "雑誌・新聞等の記事",
                                "イベント・セミナー等",
                                "TRIPORTからのキャンペーンやお知らせメール",
                                "TRIPORTのサービスを現在利用している",
                                "TRIPORTのサービスを過去に利用していた",
                                "その他"
                              ].map((item,index)=>{
                                return <FormControlLabel 
                                    key={`${item}`}
                                    value={`${item}`}
                                    label={item}
                                    control={<Radio/>}/>
                                })
                              }
                            </RadioGroup>
                            <FormHelperText sx={{ml:1}} error={!!fieldState.error?.message}>{fieldState.error?.message}</FormHelperText>
                          </>
                        }/>
                      
                      </Box>

                     
                      <Stack mt={5}  direction={'column'} spacing={2} justifyContent={"center"} alignItems={"center"}>
                          <Box>個人情報は、<a href="https://triport.co.jp/privacy" target="_blank" rel="noreferrer">プライバシーポリシー</a>に基づき厳重に管理いたします。</Box>
                          <Button type="submit" variant="contained" size="large" sx={{mt:2,paddingY:2, paddingX:{xs:2,sm:4},fontSize:{xs:18,md:20},fontWeight:"bold"}} disabled={!isValid || isSubmitting}>プライバシーポリシーに同意のうえ送信する</Button>
                      </Stack>
                  </Box>
              }

              {isCompleted===true &&
                  <Box >
                      
                      <Box>お問い合わせいただき、誠にありがとうございます。</Box>
                      
                      <Box mt={2}>お問い合わせ内容を確認させていただき、継続的なコンタクトが必要と判断したお問い合わせにつきましては、</Box>
                      <Box>２営業日以内に弊社担当者よりご連絡をさせていただきます。</Box>
                      
                  </Box>
              }
          </Box>
          

          
          
          
          <Backdrop
              sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={isProcessing}>
              <CircularProgress style={{width:"60px",height:"60px"}} />
          </Backdrop>
          
          <Dialog
              fullWidth={true}
              maxWidth={"md"}
              open={dialogInfo != null}
              onClose={() => { setDialogInfo(null); }}>
              <DialogTitle>{dialogInfo?.title}</DialogTitle>
              <DialogContent dividers sx={{overflowWrap:"break-word",whiteSpace:"pre-line"}}>
                  <DialogContentText>{dialogInfo?.message}</DialogContentText>
              </DialogContent>
              <DialogActions>
                  <Button onClick={() => { setDialogInfo(null); }} autoFocus>閉じる</Button>
              </DialogActions>
          </Dialog>


            
        </Box>
        {/* <Box sx={{position:"fixed",bottom:"0",left:"0",right:"0",background:"#454545",color:"white", padding:"5px 0", textAlign: "center"}}>2024 TRIPORT</Box> */}
    </Box>
    </>
  );
}

export default Contact;
